import { render, staticRenderFns } from "./BotoneraMantenedor.vue?vue&type=template&id=67243ccc"
import script from "./BotoneraMantenedor.vue?vue&type=script&lang=js"
export * from "./BotoneraMantenedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports